import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { MessageCard, QuoteCard, Button, MetaModal, Content } from '@simplybenefits/sb-ui-library';
import { createQuote } from '../../actions/quotes.js';
import permissionLevel from '../../services/permissions.js';

class Quotes extends PureComponent {
    state = {
        showModal: false
    };

    static getDerivedStateFromProps(props) {
        if (!permissionLevel('Quotes', props.accessType).includes('read')) {
            window.location.href = '/403';
        }

        return null;
    }

    _showModal = () => {
        this.setState({
            showModal: true
        });
    };

    _hideModal = () => {
        this.setState({
            showModal: false
        });
    };

    render() {
        return (
            <Content>
                {
                    this.props.quotes.length > 0 &&
                        <Button
                            id="view-history"
                            color="primary"
                            customStyle={{
                                display: 'block',
                                height: 50,
                                width: 180,
                                textTransform: "capitalize",
                                fontSize: 16,
                                marginBottom: 2.5,
                                marginLeft: 'auto'
                            }}
                            onClick={ this._showModal }
                        >
                            Create Quote
                        </Button>
                }

                {
                    this.props.quotes.length === 0 ?
                        <MessageCard
                            title="No Quotes!"
                            subtitle='You do not have any in progress quotes. Use the "Create Quote" button below to get started.'
                            btn
                            btnName="Create Quote"
                            btnOnClick={this._showModal}
                        />
                        :
                        this.props.quotes.map((quote) => (
                            <QuoteCard
                                key={ quote.quoteID }
                                quote={quote}
                                whitelabel={{}}
                                link={
                                    quote.status.toUpperCase() === 'SOLD' ?
                                        `/accounts/${ quote.accountID }`
                                        :
                                        `/advisors/${ this.props.currentAdvisor.advisorID }/quotes/${ quote.quoteID }`
                                }
                            />
                        ))
                }

                <MetaModal
                    hideModal={this._hideModal}
                    showModal={this.state.showModal}
                    loading={this.props.loading}
                    create={ (...params) => this.props.dispatch(createQuote(this.props.currentAdvisor.advisorID, ...params)) }
                    isMasterSite={ true }
                    isQuote={ true }
                    advisorMeta={ this.props.currentAdvisor }
                    agents={ this.props.agents }
                    permissionLevel={ (type) => permissionLevel(type, this.props.accessType) }
                />

                <span id="quotes" />
            </Content>
        );
    }
}

Quotes.propTypes = {
    quotes: PropTypes.array
};

/**
 * @param state
 * @returns {{accounts: Array, loading: boolean}}
 */
const mapStateToProps = (state) => ({
    quotes: state.advisors.currentAdvisor.quotes,
    currentAdvisor: state.advisors.currentAdvisor,
    accessType: state.master.access,
    agents: state.master.agents,
    loader: state.loader
});

export default connect(mapStateToProps)(Quotes);